<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Corretores</li>
        </ol>

        <div class="row">
          <div class="col-md-12 ">
            <div class="pull-right">
              <router-link to="corretores/criar-corretor" class="btn_1 medium mb-3">Criar novo Corretor</router-link>
            </div>
          </div>
        </div>

        <v-card>
          <v-card-title>
            <h3>Corretores</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          
          <v-data-table :no-data-text="textoTabela" :headers="headers" :items="corretores" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props">
              <tr v-if="!(props.item.deleted_at)">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.nome_completo }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ padronizaData(props.item.created_at) }}</td>
                <td class="text-xs-right">
                  <router-link
                    class="btn_1 grey delete wishlist_close"
                    :to="'corretores/' + props.item.id"
                  >
                    <i class="fa fa-eye"></i> Detalhes
                  </router-link>

                  <a
                    href="javascript:void(0)"
                    class="btn_1 red delete wishlist_close"
                    v-if="props.item.deleted_at == null"
                    @click.prevent="desativacorretor(props.item.id)"
                  >
                    Desativar
                  </a>
                </td>
              </tr>
            </template>
            
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import axios from "axios";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      pagination: {}, // Adicionado para evitar erro de undefined se não inicializado
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome_completo" },
        { text: "E-mail", value: "email"},
        { text: "Data de criação", value: "created_at" },
        { text: "Ações", value: "", sortable: false }
      ],
      corretores: [],
      isLoading: false,
      textoTabela: "Nenhum registro encontrado"
    };
  },
  mounted() {
    this.carregarCorretores();
  },
  methods: {
    carregarCorretores() {
      let token_adm = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (!token_adm) return;

      let operadora = token_adm.id_operadora;
      this.isLoading = true;

      axios.get(`corretores`)
        .then((res) => {
          // Filtra e formata os dados
          this.corretores = res.data
            .filter(c => c.provider_id == operadora)
            .map(c => ({
              ...c,
              nome_completo: `${c.name || ''} ${c.last_name || ''}`.trim()
            }));
        })
        .catch((err) => {
          tratamento_requisicao(err, this);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    desativacorretor(id) {
      if (!confirm("Tem certeza que deseja desativar este corretor?")) return;

      this.isLoading = true;
      ajax("delete", `corretores/${id}`)
        .then(() => {
          alerta("success", "Desativado", "Corretor desativado com sucesso!");
          this.carregarCorretores(); // Recarrega a lista para atualizar a UI
        })
        .catch(error => {
          tratamento_requisicao(error, this);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>